import { Link } from "react-router-dom";
import {
  faBed,
  faBath,
  faHouse,
  faStore,
  faRulerCombined,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ListingCard({ property, image, type }) {
  console.log("type of", typeof (property.PropertyType))
  return (
    <Link
      to={`/listing/${property.ListingKey}`}
      className="group block min-w-0"
    >
      <div className="w-full min-w-0 overflow-hidden rounded-2xl bg-white border border-slate-100 shadow-md transition-all duration-500 hover:-translate-y-1 hover:shadow-xl">
        {/* Image */}
        <div className="relative aspect-[5/3] overflow-hidden">
          <img
            // src={image?.MediaURL ?? "/placeholder.jpg"}
            src={image}
            alt={property.UnparsedAddress ?? "Property"}
            className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
          />

          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-4 py-5">
            <p className="text-xs uppercase tracking-widest text-white">
              {property.CityRegion ?? property.CrossStreet ?? "Location"}
            </p>
          </div>
        </div>


        {/* Content */}
        <div className="p-4">
          <h3 className="truncate text-lg font-semibold text-slate-800">
            {property.UnparsedAddress ?? "Beautiful Property"}
          </h3>


          {/* Details */}
          <div className="mt-4 flex items-center justify-between text-sm text-slate-500">
            {property.PropertyType?.toLowerCase().includes("residential") && (
              <>
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faBed} className="text-summit-highlight" />
                  <span className="font-medium text-slate-700">
                    {property.BedroomsTotal ?? "-"}
                  </span>
                </div>


                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faBath} className="text-summit-highlight" />
                  <span className="font-medium text-slate-700">
                    {property.BathroomsTotalInteger ?? "-"}
                  </span>
                </div>
              </>
            )}

            {property.PropertyType?.toLowerCase().includes("commercial") && (
              <>
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faStore} className="text-summit-highlight" />
                  <span className="font-medium text-slate-700">
                    {property.PropertySubType ?? "-"}
                  </span>
                </div>


                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faRulerCombined} className="text-summit-highlight" />
                  <span className="font-medium text-slate-700">
                    {property?.LivingAreaRange || property?.BuildingAreaTotal || "--" || "-"}
                  </span>
                </div>
              </>
            )}


            <div className="flex items-center gap-2 max-w-[120px]">
              <FontAwesomeIcon icon={faHouse} className="text-summit-highlight" />
              <span className="truncate font-medium text-slate-700">
                {property.PropertyType ?? "-"}
              </span>
            </div>

          </div>


          {/* Price */}
          <div className="mt-5 flex items-center justify-between">

            <p className="text-xl font-semibold text-slate-900">
              {property.ListPrice
                ? `$${property.ListPrice.toLocaleString()}`
                : ""}
            </p>


            <span className="text-[11px] uppercase tracking-[0.25em] text-summit-highlight transition group-hover:underline">
              Details
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}